angular.module('callX').service('NotificationsService', ['$http', '$rootScope', 'UserService',
  function ($http){

      var getNotifications = function(callbacks){
          $http.get("/japi/user-notification")
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var updateNotification = function(id, responseData, callbacks){
          $http.put("/japi/user-notification/"+id, responseData)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

      var markAsViewed = function(notificationIds, callbacks){
          $http.put("/japi/user-notification-viewed/0", {notifications: notificationIds})
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };

    return {
      getNotifications: function (callbacks) {
         getNotifications(callbacks);
      },
      updateNotification: function (id, data, callbacks) {
         updateNotification(id, data, callbacks);
      },
      markAsViewed: function (notificationIds, callbacks) {
         markAsViewed(notificationIds, callbacks);
      }
    };
  }]);